import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/menu/header';
import Footer from '../components/menu/footer';
import API from '../api/API';
import './iscrizioni.css';

const Iscrizioni = () => {
  const navigate = useNavigate();
  const [tornei, setTornei] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTornei();
  }, []);

  const fetchTornei = async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await API.iscrizioni.disponibili();
      
      if (response.isSuccess !== false && response.data !== undefined) {
        if (Array.isArray(response.data)) {
          setTornei(response.data);
        } else if (response.data && typeof response.data === 'object') {
          const possibleArrays = Object.values(response.data).filter(val => Array.isArray(val));
          if (possibleArrays.length > 0) {
            setTornei(possibleArrays[0]);
          } else {
            setTornei([response.data]);
          }
        } else {
          setTornei([]);
        }
      } else {
        setError(`Errore nel caricamento dei tornei: ${response.errorMsg || 'Risposta non valida'}`);
      }
    } catch (error) {
      setError(`Errore di connessione: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (dateString) => {
    if (!dateString) return 'Data non disponibile';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'Data non valida';
    }
  };

  const formatDataChiusura = (dateString) => {
    if (!dateString) return 'Non specificata';
    
    try {
      const date = new Date(dateString);
      const now = new Date();
      const isScaduta = date < now;
      
      const formattedDate = date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      
      return { date: formattedDate, isScaduta };
    } catch (error) {
      return { date: 'Data non valida', isScaduta: false };
    }
  };

  const handleIscriviti = (torneoId) => {
    navigate(`/tornei/iscrizione/${torneoId}`);
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="iscrizioni-loading-container">
          <div className="iscrizioni-loading-spinner"></div>
          <p>Caricamento tornei...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="iscrizioni-error-container">
          <h1>Errore</h1>
          <p>{error}</p>
          <button onClick={fetchTornei} className="iscrizioni-retry-button">
            Ricarica
          </button>
        </div>
      );
    }

    if (tornei.length === 0) {
      return (
        <div className="iscrizioni-no-tournaments">
          <i className="fas fa-trophy"></i>
          <h3>Nessun torneo disponibile</h3>
          <p>Al momento non ci sono tornei aperti per le iscrizioni.</p>
        </div>
      );
    }

    return (
      <div className="iscrizioni-tournaments-grid">
        {tornei.map((torneo, index) => {
          const chiusuraInfo = formatDataChiusura(torneo.chiusuraIscrizioni);
          const isIscrizioniChiuse = chiusuraInfo.isScaduta;
          
          return (
            <div key={torneo.id || index} className="iscrizioni-tournament-card">
              {/* Immagine di sfondo */}
              {torneo.locandina ? (
                <img
                  className="iscrizioni-tournament-bg"
                  src={`data:image/jpeg;base64,${torneo.locandina}`}
                  alt={`Locandina ${torneo.nome}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              ) : (
                <div className="iscrizioni-tournament-placeholder">
                  <i className="fas fa-trophy"></i>
                </div>
              )}

              {/* Info overlay in basso */}
              <div className="iscrizioni-tournament-info">
                <div className="iscrizioni-tournament-header">
                  <h3 className="iscrizioni-tournament-name">{torneo.nome || 'Nome non disponibile'}</h3>
                  <span className="iscrizioni-tournament-edition">{torneo.edizione || 'N/A'} ED.</span>
                </div>

                <div className="iscrizioni-tournament-details">
                  <div className="iscrizioni-detail-item">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{formatData(torneo.data)}</span>
                  </div>

                  <div className="iscrizioni-detail-item">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>{torneo.luogo || 'Luogo non specificato'}</span>
                  </div>

                  <div className="iscrizioni-detail-item">
                    <i className="fas fa-clock"></i>
                    <span>
                      Chiusura iscrizioni: {chiusuraInfo.date}
                    </span>
                  </div>
                </div>

                <div className="iscrizioni-tournament-actions">
                  {isIscrizioniChiuse ? (
                    <div className="iscrizioni-closed-inscription">
                      <i className="fas fa-times-circle"></i>
                      <span>Iscrizioni chiuse</span>
                    </div>
                  ) : (
                    <button
                      className="iscrizioni-inscription-button"
                      onClick={() => handleIscriviti(torneo.id)}
                    >
                      <i className="fas fa-user-plus"></i>
                      Iscriviti
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="iscrizioni-page">
      <Header />
      
      <main className="iscrizioni-main">
        <div className="iscrizioni-page-container">
          <h1>Iscrizioni Tornei</h1>
          {renderContent()}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Iscrizioni;